
export default {
    name: 'Theme3DesktopExchangeRate',
}
